// ページ非公開中

import { isDomContentLoaded } from './modules/get_perfomance'
import { getApiUrlString, setUrlMap } from './modules/get_apiUrlString'
import { getCode } from './modules/get_code'

(() => {

  const init = () => {
    setUrlMap(window.pist6);
    const worker = new Worker('/assets/js/data/worker/api_thread.js');
    const queryString = ``;
    worker.postMessage({
      url: getApiUrlString('tournament2', queryString),
      cb: (cb).toString()
    })
    worker.addEventListener('message', evt => {
      if (isDomContentLoaded()) {
        buildProgram(evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildProgram(evt.data);
        })
      }
    })
  }

  const cb = (data) => {
    const dailyScheduleList = data.api.hold_daily_schedule_list.map(race => {
        race.datetime = (new Date(race.event_date)).getTime();
        race.event_date = race.event_date.replace(/-/g, '.')
        race.zone_txt = race.day_night == 0 ? 'デイ' : 'ナイト';
        race.zone_cls = race.day_night == 0 ? '_day' : '_night';
        race.year = race.promoter_year % 1000;
        return race
      })
      .slice(0, 4);
    postMessage(dailyScheduleList);
  }

  const buildProgram = (data) => {
    const raceProgramUl = document.querySelector('.le-race-program');
    const programSlot = raceProgramUl.firstElementChild;
    const fragmentElement = document.createDocumentFragment();

    if (data.length) {
      data.forEach(info => {
        const cloneNode = programSlot.cloneNode(true);
        cloneNode.querySelector('.le-race-program__date').textContent = info.event_date;
        cloneNode.querySelector('.le-race-program__time-num').textContent = info.event_time;
        cloneNode.querySelector('.le-race-program__name-txt').textContent = `${info.year}-${info.year + 1} ${getCode('seasonText', info.season).ja || 'ー'} ${getCode('round', info.round_code).name || 'ー'}`;
        const zone = cloneNode.querySelector('.le-race-program__zone');
        zone.textContent = info.zone_txt;
        zone.classList.add(info.zone_cls);

        // リーグラウンド情報への導線復帰は下記を true に変更
        const isConductor = false;
        if (isConductor) {
          const raceClassification = (() => {
            const raceObj = getCode('race', info.event_code);
            if (raceObj.en) {
              return raceObj.en.replace(/\s/g, '').toLowerCase();
            } else {
              return 'qualifying';
            }
          })()
          cloneNode.querySelector('.le-race-program__link').href = `/league/${raceClassification}/?year=${info.promoter_year}&season=${info.season}&round_code=${info.round_code}`;

          fragmentElement.appendChild(cloneNode);
        } else {
          const appendNode = cloneNode.cloneNode();
          const childElements = cloneNode.firstElementChild.children;
          [].map.call(childElements, childElement => childElement)
            .forEach(childElement => {
              appendNode.appendChild(childElement);
            })
          fragmentElement.appendChild(appendNode);
        }
      });
    } else {
      const cloneNode = programSlot.cloneNode();
      const divElement = document.createElement('div');
      divElement.classList.add('le-race-program__empty');
      divElement.innerHTML = '<p class="le-race-program__empty-txt">今週開催されるレースはありませんでした</p>';
      cloneNode.appendChild(divElement);
      fragmentElement.appendChild(cloneNode);
    }

    raceProgramUl.innerHTML = '';
    raceProgramUl.appendChild(fragmentElement);
    raceProgramUl.removeAttribute('aria-hidden');
    raceProgramUl.classList.remove('_skelton');
  }

  init();
})();


